export enum TicketStatus {
  CHOTIEPNHAN = 6,
  DANGXULY = 7,
  HOANTAT = 8,
  CHUYENTRUNGTAM = 9,
  HUY = 10,
  TRUONGCACHUYENPHONG = 11,
  TRUONGCACHUYENPHONGKYTHUAT = 12
}
